export default __webpack_public_path__ + "static/media/5w-40 Qualia L.5eb7eef4.png";